import { connect } from 'react-redux'
import Share from './Share.jsx'
import { closeSocialSharing } from '../../../../redux/share/actions'
import { getShareActions } from '../../../../redux/share/selectors'

const mapStateToProps = state => ({
    getShareActions: (state) => getShareActions(state),
})

const mapDispatchToProps = (dispatch, getState) => ({
    close: () => dispatch(closeSocialSharing())
})

export const ShareContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Share)
